module.exports = __webpack_public_path__ + "static/media/sniper_bow.f0be8b1a.png";